const csvTemplate = `customer_code,sku,is_active
TGR1-10064,AU.SC-SPMW1001,yes
TGR1-10065,AU.SC-SPDCCF1,no`;

export default csvTemplate;
